export class ErrorWithToastData extends Error {
  public title: string;
  public body?: string;

  constructor(title: string, body?: string, message?: string) {
    super(message ?? title);
    this.title = title;
    this.body = body;
    Object.setPrototypeOf(this, new.target.prototype);
  }
}
